import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between py-1 text-white px-7 bg-secondary-dark-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Potential Score", -1)


export default /*#__PURE__*/_defineComponent({
  props: {
  score: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, _toDisplayString(__props.score), 1)
  ]))
}
}

})